import { API } from "aws-amplify";
import { API_NAME } from "../common/constants";

export const postNotificationDocsNotify = async (
  notificationDocsNo: string,
  yearMonth: string,
  subject: string,
  body: string
) => {
  const path = `/notification-docs-notify/${encodeURIComponent(
    notificationDocsNo
  )}?year_month=${yearMonth}`;
  const params = { body: { subject, body } };
  let result: any;
  await API.post(API_NAME, path, params)
    .then((response) => {
      result = response;
    })
    .catch((e) => {
      console.error(e);
      result = e.response.data;
    });
  return result;
};
